<template>
    <div id="printableArea">
        <div class="container-fluid pt-4" dir="rtl">
            <div class="d-flex justify-content-end mb-2">
                <export-excel class="btn btn-dark no-print" :data="DataAxios.SalaryDetials" :fields="json_fields" :title="'لیست حقوق' + '_' + DataAxios.WorkshopName + '_' + DataAxios.Year + '_' + DataAxios.Month"
                    :worksheet="DataAxios.Year + '_' + DataAxios.Month"
                    :name="'لیست حقوق' + '_' + DataAxios.WorkshopName + '_' + DataAxios.Year + '_' + DataAxios.Month">
                    دریافت اکسل
                </export-excel>
                <button class="bg-success btn no-print mx-2 text-light Pointer" @click="GetPrint()"> چــاپ</button>
                <button class="bg-warning btn no-print text-light Pointer" @click="$router.go(-1)"> بازگشت </button>
            </div>
            <table class="table table-bordered border-dark text-center">
                <thead style="background-color: rgb(245, 245, 245) !important;">
                    <tr>
                        <th colspan="11">
                            <div class="my-1 mb-2">
                                {{ DataAxios.WorkshopName }}
                            </div>
                            لیست حقوق و دستمزد
                            {{ DataAxios.Month }}
                            ماه
                            {{ DataAxios.Year }}
                        </th>
                    </tr>
                    <tr class="font-weight-normal">
                        <th style="width: 14%;">
                            ردیف
                        </th>
                        <th style="width: 8%;">
                            کارکرد
                        </th>
                        <th style="width: 10%;">
                            مزد روزانه
                        </th>
                        <th style="width: 8%;">
                            ساعت اضافه کاری
                        </th>
                        <th style="width: 14%;" rowspan="2">
                            مزایا
                        </th>
                        <th style="width: 12%;" rowspan="2">
                            کسورات
                        </th>
                        <th style="width: 12%;">
                            جمع حقوق و مزایا
                        </th>
                        <th style="width: 10%;">
                            بیمه پرداختنی
                        </th>
                        <th style="width: 10%;">
                            جمع کسورات
                        </th>
                    </tr>
                    <tr class="font-weight-normal">
                        <th>
                            نام و نام خانوادگی
                        </th>
                        <th>
                            شماره بیمه
                        </th>
                        <th>
                            مزد ماهانه
                        </th>
                        <th>
                            اضافه کاری
                        </th>
                        <th>
                            جمع حقوق و مزایا مشمول
                        </th>
                        <th>
                            مالیات پرداختنی
                        </th>
                        <th>
                            خالص پرداختی
                        </th>
                    </tr>
                </thead>
                <tbody v-for="(item, index) in DataAxios.SalaryDetials " :key="index" style="border-bottom: 2.5px solid black;">
                    <tr>
                        <td class="">
                            {{ index + 1 }}
                        </td>
                        <td class=" ">
                            <p v-if="item.WorkPerformanceDaily > 0">{{ item.WorkPerformanceDaily }}</p>
                        </td>
                        <td class=" ">
                            <p v-if="item.DailySalary > 0">{{ $Comma3ragham(item.DailySalary) }}</p>
                        </td>
                        <td class=" " dir="ltr">
                            <p>{{ item.AddWorkHourse }}</p>
                        </td>
                        <td rowspan="2" class=" ">
                            <table width="100%" class="NoBorder">
                                <tr>
                                    <td align="right">
                                        <p v-if="item.Benefits.Home > 0">حق مسکن</p>
                                        <p v-if="item.Benefits.Bone > 0">حق بن</p>
                                        <p v-if="item.Benefits.Misson > 0">ماموریت</p>
                                        <p v-if="item.Benefits.Sanavat > 0">پایه سنوات</p>
                                        <p v-if="item.Benefits.Skill > 0">مهارت</p>
                                        <p v-if="item.Benefits.Education > 0">حق تحصیلات</p>
                                        <p v-if="item.Benefits.Amazing > 0">فوق العاده</p>
                                        <p v-if="item.Benefits.Rewards > 0">پاداش</p>
                                        <p v-if="item.Benefits.HageJazb > 0">حق جذب</p>
                                        <p v-if="item.Benefits.HageShift > 0">حق شیفت</p>
                                        <p v-if="item.Benefits.HardWork > 0">سختی کار</p>
                                        <p v-if="item.Benefits.Food > 0">حق غذا</p>
                                        <p v-if="item.Benefits.Cashier > 0">صندوقدار</p>
                                        <p v-if="item.Benefits.Cashier > 0">ایاب و ذهاب</p>
                                        <p v-if="item.Benefits.Eidi > 0">عیدی</p>
                                        <p v-if="item.Benefits.Child > 0">حق اولاد</p>
                                        <p v-if="item.Benefits.OtherBenefits > 0">سایر مزایا</p>
                                        <p v-if="item.Benefits.YearSanavat > 0">سنوات پایان سال</p>
                                    </td>
                                    <td align="left">
                                        <p v-if="item.Benefits.Home > 0">{{ $Comma3ragham(item.Benefits.Home) }}</p>
                                        <p v-if="item.Benefits.Bone > 0">{{ $Comma3ragham(item.Benefits.Bone) }}</p>
                                        <p v-if="item.Benefits.Misson > 0">{{ $Comma3ragham(item.Benefits.Misson) }}</p>
                                        <p v-if="item.Benefits.Sanavat > 0">{{ $Comma3ragham(item.Benefits.Sanavat) }}</p>
                                        <p v-if="item.Benefits.Skill > 0">{{ $Comma3ragham(item.Benefits.Skill) }}</p>
                                        <p v-if="item.Benefits.Education > 0">{{ $Comma3ragham(item.Benefits.Education) }}
                                        </p>
                                        <p v-if="item.Benefits.Amazing > 0">{{ $Comma3ragham(item.Benefits.Amazing) }}</p>
                                        <p v-if="item.Benefits.Rewards > 0">{{ $Comma3ragham(item.Benefits.Rewards) }}</p>
                                        <p v-if="item.Benefits.HageJazb > 0">{{ $Comma3ragham(item.Benefits.HageJazb) }}</p>
                                        <p v-if="item.Benefits.HageShift > 0">{{ $Comma3ragham(item.Benefits.HageShift) }}
                                        </p>
                                        <p v-if="item.Benefits.HardWork > 0">{{ $Comma3ragham(item.Benefits.HardWork) }}</p>
                                        <p v-if="item.Benefits.Food > 0">{{ $Comma3ragham(item.Benefits.Food) }}</p>
                                        <p v-if="item.Benefits.Cashier > 0">{{ $Comma3ragham(item.Benefits.Cashier) }}</p>
                                        <p v-if="item.Benefits.Transportation > 0"> {{
                                            $Comma3ragham(item.Benefits.Transportation) }}</p>
                                        <p v-if="item.Benefits.Eidi > 0">{{ $Comma3ragham(item.Benefits.Eidi) }}</p>
                                        <p v-if="item.Benefits.Child > 0">{{ $Comma3ragham(item.Benefits.Child) }}</p>
                                        <p v-if="item.Benefits.OtherBenefits > 0">{{
                                            $Comma3ragham(item.Benefits.OtherBenefits) }}</p>
                                        <p v-if="item.Benefits.YearSanavat > 0">{{ $Comma3ragham(item.Benefits.YearSanavat)
                                        }}
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td rowspan="2" class=" ">
                            <table width="100%" class="NoBorder">
                                <tr>
                                    <td align="right">
                                        <p v-if="item.Deductions.Bime > 0">بیمه </p>
                                        <p v-if="item.Deductions.BimeTakmily > 0">بیمه تکمیلی</p>
                                        <p v-if="item.Deductions.Sos > 0">مساعده </p>
                                        <p v-if="item.Deductions.Facility > 0">تسهیلات </p>
                                        <p v-if="item.Deductions.Tax > 0">مالیات </p>
                                        <p v-if="item.Deductions.MissOther > 0">سایر کسورات </p>
                                        <p v-if="item.Deductions.MissPerformance > 0">کسری کار</p>
                                    </td>

                                    <td align="left">
                                        <p v-if="item.Deductions.Bime > 0">{{ $Comma3ragham(item.Deductions.Bime) }}</p>
                                        <p v-if="item.Deductions.BimeTakmily > 0">
                                            {{ $Comma3ragham(item.Deductions.BimeTakmily) }}</p>
                                        <p v-if="item.Deductions.Sos > 0">{{ $Comma3ragham(item.Deductions.Sos) }}</p>
                                        <p v-if="item.Deductions.Facility > 0">{{ $Comma3ragham(item.Deductions.Facility) }}
                                        </p>
                                        <p v-if="item.Deductions.Tax > 0">{{ $Comma3ragham(item.Deductions.Tax) }}</p>
                                        <p v-if="item.Deductions.MissOther > 0">{{ $Comma3ragham(item.Deductions.MissOther)
                                        }}
                                        </p>
                                        <p v-if="item.Deductions.MissPerformance > 0">
                                            {{ $Comma3ragham(item.Deductions.MissPerformance) }}</p>
                                    </td>


                                </tr>
                            </table>
                        </td>
                        <td class=" ">{{ $Comma3ragham(item.SumSalaryAndBenefits) }}</td>
                        <td class=" ">{{ $Comma3ragham(item.BimeKarmand) }}</td>
                        <td class=" ">{{ $Comma3ragham(item.SumDeductions) }}</td>
                    </tr>
                    <tr>
                        <td class="">
                            {{ item.NamFam }}

                        </td>
                        <td class=" ">
                            {{ item.InsuranceNumber }}
                        </td>
                        <td class=" ">
                            <p>{{ $Comma3ragham(item.MonthlySalary) }}</p>
                        </td>
                        <td class=" ">
                            <p>{{ $Comma3ragham(item.AddWorkPrice) }}</p>
                        </td>
                        <td class=" ">
                            <p>{{ $Comma3ragham(item.SumMashmolBime) }}</p>
                        </td>
                        <td class=" ">
                            <p>{{ $Comma3ragham(item.Tax) }}</p>
                        </td>
                        <td class=" ">
                            <p>{{ $Comma3ragham(item.NetPayment) }}</p>
                        </td>
                    </tr>

                </tbody>
                <tfoot style="background-color: rgb(245, 245, 245) !important;">
                    <tr>
                        <th align="center" rowspan="2">
                            جمع
                        </th>
                        <th rowspan="2">
                            {{ DataAxios.SumWorkPerformanceDaily }}
                        </th>
                        <th>{{ $Comma3ragham(DataAxios.SumDailySalary) }}</th>
                        <th dir="ltr">
                            {{ DataAxios.SumAddWorkHourse }}

                        </th>
                        <th rowspan="2">{{ $Comma3ragham(DataAxios.SumBenfits) }} </th>
                        <th rowspan="2">{{ $Comma3ragham(DataAxios.SumDeductions) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumKolSalaryAndBenefits) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumBimeKarmand) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumKolDeductions) }}</th>
                    </tr>
                    <tr>
                        <th>{{ $Comma3ragham(DataAxios.SumMonthlySalary) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumAddWork) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumMashmolBime) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumTax) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumNetPayment) }}</th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            DataAxios: {},
            SalaryId: 0,
            json_fields: {
                'نام و نام خانوادگی': 'NamFam',
                'کارکرد روزانه': 'WorkPerformanceDaily',
                'شماره بیمه': 'InsuranceNumber',
                'مزد روزانه': 'DailySalary',
                'مزد ماهانه': 'MonthlySalary',
                'ساعت اضافه کاری': 'AddWorkHourse',
                'اضافه کاری': 'AddWorkPrice',
                'حق اولاد': 'Benefits.Child',
                'حق مسکن': 'Benefits.Home',
                'حق بن': 'Benefits.Bone',
                'پایه سنوات': 'Benefits.Sanavat',
                'مهارت': 'Benefits.Skill',
                'حق مسئولیت': 'Benefits.Responsibility',
                'حق تحصیلات': 'Benefits.Education',
                'فوق العاده': 'Benefits.Amazing',
                'حق جذب': 'Benefits.HageJazb',
                'حق شیفت': 'Benefits.HageShift',
                'سختی کار': 'Benefits.HardWork',
                'حق غذا': 'Benefits.Food',
                'صندوقدار': 'Benefits.Cashier',
                'ایاب و ذهاب': 'Benefits.Transportation',
                'سایر مزایا': 'Benefits.OtherBenefits',
                'پاداش': 'Benefits.Rewards',
                'عیدی': 'Benefits.Eidi',
                'سنوات پایان سال': 'Benefits.YearSanavat',
                'ماموریت': 'Benefits.Misson',
                'کسری کار': 'Deductions.MissPerformance',
                'مساعده': 'Deductions.Sos',
                'تسهیلات': 'Deductions.Facility',
                'بیمه تکمیلی': 'Deductions.BimeTakmily',
                'سایر کسورات': 'Deductions.MissOther',
                'مالیات پرداختنی': 'Tax',
                'بیمه پرداختنی': 'BimeKarmand',
                'جمع حقوق و مزایا': 'SumSalaryAndBenefits',
                'جمع حقوق و مزایا مشمول': 'SumMashmolBime',
                'جمع کسورات': 'SumDeductions',
                'خالص پرداختی': 'NetPayment',
            },

            json_meta: [
                [
                    {
                        'key': 'charset',
                        'value': 'utf-8'
                    }
                ]
            ],

        }
    },
    components: {},
    beforeMount() {
        this.SalaryId = this.$route.query.SalaryId
    },
    mounted() {

        this.GetData()
    },
    methods: {

        GetPrint() {
            var mywindow = window.open('', 'PRINT')

            mywindow.document.write('<html><head>')
            mywindow.document.write('<link rel="stylesheet" href="/assets/bootstrap/bootstrap.min.css"  >')
            mywindow.document.write('<link rel="stylesheet" href="/assets/iransans/font-face-Sans.css">')
            mywindow.document.write('<link rel="stylesheet" href="/assets/print/FishPrint.css">')
            mywindow.document.write('</head><body onload="window.print()" dir="rtl">')
            mywindow.document.write(document.getElementById('printableArea').innerHTML)
            mywindow.document.write('</body></html>')
            mywindow.document.close()
            mywindow.focus()
            mywindow.document.close()

        },
        GetData() {
            var DataAxois = {
                ArryfildValue: {}, Method: 'Get', Action: 'SalaryReport/GetSalaryList/' + this.SalaryId, Token: this.$session.get('Token'),
            }
            this.$PostData(DataAxois).then((data) => {
                if (data != null) {
                    if (data.IsSuccess == true) {
                        // console.log(data);
                        this.DataAxios = data.Data
                    }
                }
            }).finally(() => {

            });
        },
    }
}
</script>
<style scoped>
@media print {

    .no-print {
        display: none;
    }
}

*{
    font-weight: 900;
}

tr {
    color: var(--sidebar-color-item) !important;

}

table {
    background: var(--sidebar-bg-color) !important;
    color: var(--sidebar-color-item);
}

td {
    border-color: var(--table-border-color) !important;

}

th {
    font-weight: 900;
    text-align: center;
    color: var(--sidebar-color-item) !important;
    border-color: var(--table-border-color) !important;
}

thead {
    border-color: var(--table-border-color) !important;
}

tr:hover {
    color: var(--sidebar-color-item) !important;
    background: var(--sidebar-bg-color) !important;
}
</style>
